// Converts milliseconds to 'm:ss' or 'xxxms' or '-' if falsy
export const formatMsToMinSec = milliseconds => {
  const NOT_AVAILABLE = '-';
  if (!milliseconds) return NOT_AVAILABLE;
  if (milliseconds < 1000) return `${milliseconds}ms`;
  const minutes = Math.floor(milliseconds / 60000);
  const seconds = Math.floor((milliseconds % 60000) / 1000);
  const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds;
  return `${minutes}:${formattedSeconds}`;
};
